import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AlertController, LoadingController } from "@ionic/angular";
import { LOCATION } from "../../../constant/location";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { errMsg } from "../../../text_control/error-msg";
import { _getStorage, _setStorage } from "../../../utils/local-storage";
import { BTN } from "../../../text_control/text_button";

@Component({
  selector: "app-delete-fulltax",
  templateUrl: "./delete-fulltax.component.html",
  styleUrls: ["./delete-fulltax.component.scss"],
})
export class DeleteFulltaxComponent implements OnInit {
  Active = 2;
  version_string: any = this.appService.versionString;
  startDate: string = "";
  endDate: string = "";
  bu: string = "";
  storeid: string = "";
  taxInvoiceNo: string = "";
  listLcation = [];
  listStoreid = [];
  groupBu = [];

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  constructor(
    public appService: AppService,
    public loadingController: LoadingController,
    public router: Router,
    private apiService: ApiserviceService,
    private alert: AlertController,
    public apiservice: ApiserviceService
  ) {}

  async ngOnInit() {
    let groupData = [];
    let bu = { bu: "all" };
    const bodyEncrypt = await this.apiservice.encryptBody(bu);
    const bodyReq = await this.apiservice.setBase64(bodyEncrypt);
    this.apiService
      ._get(
        this.apiService.apiUrl +
          this.apiService.getListLocation +
          `api=${bodyReq}`
      )
      .then(async (res: any) => {
        if (res.statusCode === 200) {
          this.groupBu = res.data.location;
          res.data.location.forEach((v, i) => {
            const index = groupData.findIndex((f) => f.bu === v.bu);
            if (index === -1) {
              groupData = [...groupData, v];
              this.listLcation = groupData;
            } else {
              return;
            }
          });
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
  }

  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);

    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
    }
  }

  goHomePage() {
    this.router.navigate(["/home"]);
  }

  getDateString(date: string) {
    let d = new Date(date);
    console.log("[getDateString] date : ", d);
    return `${d.getFullYear()}-${
      d.getMonth() + 1 < 10 ? `0` + (d.getMonth() + 1) : d.getMonth() + 1
    }-${d.getDate() < 10 ? `0` + d.getDate() : d.getDate()}`;
  }

  splitStringToArray(text: string) {
    if (text.indexOf(",") > -1) return text.split(",");
    if (text != "") return [text];
    return [];
  }

  storeBu(item) {
    this.listStoreid = this.groupBu.filter((f) => f.bu === item.value);
  }

  checkTaxInvoiceNo(event) {
    this.taxInvoiceNo = event.target.value.match(/[0-9]*/)[0];
  }

  validateRequest() {
    const result = {
      isNotEmpty: true,
      errMessage: "",
    };

    if (!this.bu) {
      result.isNotEmpty = false;
      result.errMessage = "กรุณากรอก bu";
      return result;
    }
    if (!this.storeid) {
      result.isNotEmpty = false;
      result.errMessage = "กรุณากรอก Store ID";
      return result;
    }
    if (!this.taxInvoiceNo) {
      result.isNotEmpty = false;
      result.errMessage = "กรุณากรอก เลขที่ใบกำกับภาษี/ใบทดแทน/ใบลดหนี้ ";
      return result;
    }

    return result;
  }

  async generateReport() {
    let validateReq = this.validateRequest();
    if (!validateReq.isNotEmpty) {
      const alert = await this.alert.create({
        cssClass: "my-custom-class",
        message: validateReq.errMessage,
        buttons: [
          {
            text: "OK",
            cssClass: "alertButton",
            handler: (blah) => {},
          },
        ],
      });
      await alert.present();
      return;
    }

    const req = {
      storeBu: this.bu,
      storeLoc: this.storeid,
      userId: this.userID,
      taxInvoiceNo: this.taxInvoiceNo,
    };
    console.log("=====req delete fulltax =====", req);
    this.apiService
      ._post(this.apiService.apiUrl + this.apiService.searchDeleteFulltax, req)
      .then((res) => {
        console.log("=====res delete fulltax =====", res);
        if (res.statusCode === 200) {
          _setStorage(STORAGE.DATA_DELETE_FULLTAX, res.data);
          this.router.navigate(["/backoffice/delete-fulltax-detail"]);
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
  }
  async ErrorMsg(message: string) {
    let alert = await this.alert.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
}
